export default __webpack_public_path__ + "static/media/rock4.b0a46039.jpg";